// @flow

const getCasesFromQty = (Qty: number) => {
  const c = parseInt(Qty, 10);

  return Number.isNaN(c) ? 0 : c;
};

export { getCasesFromQty };
